<template>
  <form @submit.prevent="passwordChange">
    <div class="container">
      <AppHeader />
      <section>
        <div class="top-bar">
          <router-link :to="{name: 'Home'}" class="button is-primary">
            <span class="icon">
              <i class="fas fa-angle-left" />
            </span>
            <span>Back to Account</span>
          </router-link>
        </div>
        <h1 class="title">Change Password</h1>
        <transition name="fade">
          <div key="1" v-if="displaySuccessMessage" class="notification is-success">
            <b>Password is updated successfully</b>
          </div>
        </transition>
        <div class="card">
          <div class="card-content">
            <div class="field is-required">
              <label class="label">Password</label>
              <p class="control has-icons-left has-icons-right">
                <input
                  class="input"
                  type="password"
                  v-model="password"
                  placeholder="Enter password"
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
              </p>
            </div>
            <div class="field is-required">
              <label class="label">Confirm Password</label>
              <p class="control has-icons-left">
                <input
                  class="input"
                  type="password"
                  v-model="confirmPassword"
                  placeholder="Re-enter Password"
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button class="button is-primary">Submit</button>
              </p>
              <p class="help is-danger" v-if="error">{{error}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>

    <AppFooter />
  </form>
</template>

<script>
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";

export default {
  name: "Password",
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      error: null,
      displaySuccessMessage: null
    };
  },
  methods: {
    passwordChange() {
      if (this.password !== this.confirmPassword) {
        this.error = "Passwords do not match";
      } else {
        this.$cnc
          .update("Account", this.$route.params.accountId, {
            password: this.password
          })
          .then(() => {
            this.displaySuccessMessage = true;
          })
          .catch(err => {
            // console.error(err);
          });
      }
    },
    back() {
      this.$router.replace({
        name: "Account-update",
        params: { accountId: this.$route.params.accountId }
      });
    }
  }
};
</script>

<style scoped>
.top-bar,
.card {
  margin-bottom: 2em;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
